import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SELECTOR = [
  'main section',
  'main .staffing-header',
  'main .about-hero',
  'main .about-section',
  'main .vision-section',
  'main .ch-reveal',
  '.home section',
  '.App section',
  '.auth-layout section',
  '.post-job-card',
].join(', ');

/**
 * Adds scroll-reveal motion to major page sections across the site.
 * Re-runs on route changes so new pages animate in.
 */
function ScrollReveal() {
  const location = useLocation();

  useEffect(() => {
    let observer;
    let cancelled = false;

    const run = () => {
      if (cancelled) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const nodes = Array.from(document.querySelectorAll(SELECTOR));

      nodes.forEach((el) => {
        if (!el.classList.contains('ch-reveal') && !el.classList.contains('ch-hero-anim')) {
          el.classList.add('ch-reveal');
        }
      });

      if (reduced) {
        nodes.forEach((el) => el.classList.add('is-inview'));
        return;
      }

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-inview');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      nodes.forEach((el) => {
        if (el.classList.contains('ch-hero-anim')) return;
        el.classList.remove('is-inview');
        observer.observe(el);
      });
    };

    // Wait a frame so PageEnter remounts land in the DOM first
    const frame = window.requestAnimationFrame(() => {
      window.setTimeout(run, 30);
    });

    return () => {
      cancelled = true;
      window.cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
    };
  }, [location.pathname]);

  return null;
}

export default ScrollReveal;
